var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Map_blanche",
    "data-name": "Map blanche",
    transform: "translate(16753 -19512)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4350",
    "data-name": "Rectangle 4350",
    width: 30,
    height: 30,
    transform: "translate(-16753 19512)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4236",
    "data-name": "Groupe 4236",
    transform: "translate(-16752.941 19513.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2972",
    "data-name": "Trac\\xE9 2972",
    d: "M84.422,195.87,75.4,192.721,81.59,179.5l5.14.933Z",
    transform: "translate(-75.4 -169.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2973",
    "data-name": "Trac\\xE9 2973",
    d: "M183.7,195.87l9.531-3.166-1.8-13.2-5.423.933Z",
    transform: "translate(-174.678 -169.412)",
    fill: "#e6e9ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2974",
    "data-name": "Trac\\xE9 2974",
    d: "M289.688,195.87,278.3,192.7l-1.8-13.2,5.7.933Z",
    transform: "translate(-259.747 -169.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_334",
    "data-name": "Groupe 334",
    transform: "translate(2.458 11.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2975",
    "data-name": "Trac\\xE9 2975",
    d: "M283.007,199.516,279.1,198.8l1.266,9.306,7.306,1.958Z",
    transform: "translate(-264.587 -198.8)",
    fill: "#a8caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2976",
    "data-name": "Trac\\xE9 2976",
    d: "M109.482,201.3,104.9,211.331l6.856,2.124,1.75-11.43Z",
    transform: "translate(-104.9 -201.092)",
    fill: "#a8caff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2977",
    "data-name": "Trac\\xE9 2977",
    d: "M194.856,198.8l-5.907.933-1.75,11.43,8.922-3.057Z",
    transform: "translate(-177.886 -187.103)",
    fill: "#75a8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M6.791,18.727v0c-.016-.021-1.715-2.071-3.4-4.56C1.846,11.868,0,8.724,0,6.788a6.789,6.789,0,0,1,13.578,0c0,1.936-1.845,5.08-3.393,7.376-1.684,2.5-3.377,4.54-3.393,4.56ZM6.783,2.793a3.439,3.439,0,1,0,3.441,3.442A3.445,3.445,0,0,0,6.783,2.793Z",
    transform: "translate(7.78 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapWhite);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };